import { Version } from "./version";

export class ParentVersion
	extends Version {

	public minorVersions = new Array<Version>();

}
